export class RoundingModel {
  hasCYRoundingDifference: boolean = false;
  hasPyRoundingDifference: boolean = false;
  cyRoundingValue: number;
  pyRoundingValue: number;
  cyDisplayValue: string;
  pyDisplayValue: string;
  isCyNegative: boolean;
  isPyNegative: boolean;
}

export class sortTypeModel {
  id: number;
  name: string;
  isManual: boolean;
}

export class CashflowSubgroupModel {
  cashFlowSubGroupId: number;
  engagementId?: number;
  subgroupRename: string;
  sortingOrder: number;
  cashFlowTypeId: number;
  finSubGroupChild?: number;
  leadSheetCode: string;
  isManual: boolean;
}

export const sortTypesOptions = [{ id: 0, name: "Automatic", isManual: false }, { id: 1, name: "Manual", isManual: true }];

export class cashFlowUtiliModel {
  isEditMainGroup: boolean = false;
  isDragDisabled: boolean = true;
  selectedSortIndex: number = -1;
}

export class CashflowYearsModel {
  engagementsid: number;
  acctyear: string;
  acctdate: string;
  periodYearId: number;
  periodYear: string;
  disabled: boolean = false; // Optional property for disabled
}

export class NonCashFlowModel {
  engagementsId: number;
  acctYear: string;
  trialBalanceId: number;
  cashFlowTypeId: number;
  cashFlowName: string;
  accountNumber: string;
  accountName: string;
  mapNo: string;
  currYearValue: number;
  prevYearValue: number;
  prevYear2Value: number;
}

export class AllTypesOfCashFlowModel {
  id: number;
  name: string;
  description: string;
  isDeleted: boolean = false;
}
